export const API_URL =
  (location.origin.indexOf('localhost') != -1 || location.origin.indexOf('dev') != -1
        ? 'https://dev.repop.shop'
    : 'https://repop.shop') + '/api';
// export const ACCOUNT_SERVER = location.origin.indexOf('localhost') != -1 || location.origin.indexOf('development') != -1 ? 'https://development.accounts.spotango.com' : 'https://accounts.spotango.com';
export const ACCOUNT_SERVER = location.origin;
export const ACCOUNT_SERVER_AUTH_CALLBACK = `${ACCOUNT_SERVER}?callback-url=${location.origin}`;
export const AUTH_TOKEN_KEY = 'authToken';
export const PRE_CAMPAIGN_ID_KEY = 'preCampaignId';
